import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ContactPage() {

    const [user, setUser] = useState({
        name: "",
        email: '',
        subject: '',
        message: ''
    });

    let name, value;
    const changeOp = (e) => {
        name = e.target.name;
        value = e.target.value;

        setUser({ ...user, [name]: value });
    };

    const Reset = () => {
        setUser({
            name: "",
            email: '',
            subject: '',
            message: ''
        });
    };

    const Submit = async (e) => {
        e.preventDefault();

        const { name, email, subject, message } = user;

        if (name && email && subject && message) {
            const url = "https://todolistcontactform-default-rtdb.firebaseio.com/todolistcontactform.json";
            const data = await fetch(url, {

                method: 'POST',
                headers: {
                    'Content-Type': "application/json",
                },
                body: JSON.stringify({
                    name,
                    email,
                    subject,
                    message
                }),
            });

            if (data) {
                setUser({
                    name: "",
                    email: '',
                    subject: '',
                    message: ''
                });
                alert("Data Store Successfully :) ")
            }

        }
        else {
            alert('Plase Fill the All Data');
        };
    };

    return (
        <>
            <div className="container my-3">
                <section id="contact" className="ftco-section">
                    <div className="container">
                        <div className="row justify-content-center">

                            <h2 className="heading-section"><b>Contact us</b> </h2> <hr />
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-12">
                                <div className="wrapper">
                                    <div className="row no-gutters">
                                        <div className="col-lg-8 col-md-7 order-md-last d-flex align-items-stretch">
                                            <div className="contact-wrap w-100 p-md-5 p-4">
                                                <h3 className="mb-4">Contact Info</h3> <hr />
                                                <div id="form-message-warning" className="mb-4"></div>

                                                <form method='POST' id="contactForm" name="contactForm" className="contactForm">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="label" htmlFor="name">Full Name</label>
                                                                <input type="text" className="form-control" name="name" value={user.name} onChange={changeOp} id="name" placeholder="Name" autoComplete='off' required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="label" htmlFor="email">Email Address</label>
                                                                <input type="email" className="form-control" name="email" value={user.email} onChange={changeOp} id="email" placeholder="Email" autoComplete='off' required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label className="label" htmlFor="subject">Subject</label>
                                                                <input type="text" className="form-control" name="subject" value={user.subject} onChange={changeOp} id="subject" placeholder="Subject" autoComplete='off' required />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label className="label" htmlFor="message">Message</label>
                                                                <textarea name="message" className="form-control" value={user.message} onChange={changeOp} id="message" cols="30" rows="4"
                                                                    placeholder="Message" autoComplete='off' required></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                                <button className='my-3 mx-3 btn btn-dark' onClick={Reset}>Reset</button>
                                                <button className='my-3 btn btn-primary' onClick={Submit}>Submit</button>
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-5 d-flex align-items-stretch">
                                            <div className="info-wrap bg-primary my-5 w-100 p-md-5 p-4">
                                                <h3>Let's get in touch</h3>
                                                <p className="mb-4">We're open for any suggestion or just to have a chat</p>
                                                <div className="dbox w-100 d-flex align-items-start">
                                                    <div className="icon d-flex align-items-center justify-content-center">
                                                        <span className="fa fa-map-marker"></span>
                                                    </div>
                                                    <div className="text pl-3">
                                                        <p><span>Address:</span> 198 West 21th Street, Suite 721 New York NY 10016
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="dbox w-100 d-flex align-items-center">
                                                    <div className="icon d-flex align-items-center justify-content-center">
                                                        <span className="fa fa-phone"></span>
                                                    </div>
                                                    <div className="text pl-3">
                                                        <p><span>Phone:</span> <Link to="tel://1234567920">+ 1235 2355 98</Link></p>
                                                    </div>
                                                </div>
                                                <div className="dbox w-100 d-flex align-items-center">
                                                    <div className="icon d-flex align-items-center justify-content-center">
                                                        <span className="fa fa-paper-plane"></span>
                                                    </div>
                                                    <div className="text pl-3">
                                                        <p><span>Email:</span> <Link to="mailto:info@yoursite.com">info@yoursite.com</Link></p>
                                                    </div>
                                                </div>
                                                <div className="dbox w-100 d-flex align-items-center">
                                                    <div className="icon d-flex align-items-center justify-content-center">
                                                        <span className="fa fa-globe"></span>
                                                    </div>
                                                    <div className="text pl-3">
                                                        <p><span>Website</span> <Link to="#">yoursite.com</Link></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
